import { useContext } from 'react'
import { ElaraRealtimeContext } from '../ElaraRealtimeProvider'
import type { ElaraRealtimeContextType } from '../types'

/**
 * Consumer hook for the ELARA Realtime context.
 * Returns null when used outside an ElaraRealtimeProvider (i.e. Elara is not enabled).
 */
export function useElara(): ElaraRealtimeContextType | null {
    return useContext(ElaraRealtimeContext) ?? null
}
